
import firebaseConfig from './firebaseConfig';

export default firebaseConfig.Environment;
